import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getPusherConfig } from '../../../services/chats';
import { IPusherConfig } from '../../../services/chats/types';

export const ThunkGetPusherConfig = createAsyncThunk<IPusherConfig>(
  `${storeResources.CHATS}/getPusherConfig`,
  () => getPusherConfig().then(res => res.data),
);
